import classNames from 'classnames';

import { createUseThemedStyles } from '@/hooks';

const useStyles = createUseThemedStyles((theme) => ({
	filterTabs: {
		display: 'flex',
		justifyContent: 'space-between',
		borderBottom: `1px solid ${theme.colors.gray300}`,
	},
	tab: {
		border: 0,
		marginRight: 32,
		...theme.fonts.s,
		padding: '20px 0',
		appearance: 'none',
		position: 'relative',
		backgroundColor: 'transparent',
		'&:last-child': {
			marginRight: 0,
		},
	},
	activeTab: {
		...theme.fonts.openSansBold,
		'&:after': {
			content: '""',
			display: 'block',
			position: 'absolute',
			left: 0,
			right: 0,
			bottom: 0,
			height: 2,
			backgroundColor: theme.colors.primary,
		},
	},
}));

interface FilterTab {
	title: string;
	value: string;
	icon?: JSX.Element | null;
}

interface FilterTabProps {
	className?: string;
	tabs: FilterTab[];
	value: string;
	onChange(value: string): void;
	aside?: JSX.Element;
}

export const FilterTabs = ({ className, tabs, value, onChange, aside }: FilterTabProps) => {
	const classes = useStyles();

	return (
		<div className={classNames(classes.filterTabs, className)}>
			<div className="d-flex">
				{tabs.map((tab, index) => {
					return (
						<button
							key={index}
							className={classNames('d-inline-flex align-items-center', {
								[classes.tab]: true,
								[classes.activeTab]: value === tab.value,
							})}
							onClick={() => {
								onChange(tab.value);
							}}
						>
							{tab.icon && <span className="d-flex text-primary mr-2">{tab.icon}</span>}
							{tab.title}
						</button>
					);
				})}
			</div>
			{aside}
		</div>
	);
};
